import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    login: {
      description: 'Adres e-mail',
      fieldRequired: true,
      format: 'email',
      title: 'Nazwa użytkownika',
      type: 'string',
      validationMessages: {
        format: 'Błąd: Nieprawidłowy format, nazwa użytkownika musi być wprowadzona w formacie nazwa@domena.'
      }
    },
    password: {
      description: 'Hasło',
      fieldRequired: true,
      title: 'Hasło',
      type: 'string'
    }
  },
  allOf: [validationMessages]
};
